/* Glambe shop helpers: shared by the concierge, builders and live bar. Needs window.GBC (snippets/gb-catalog.liquid). */
(function () {
  if (window.GBS) return;
  var CODES = { 2: '', 3: '' }; /* no discount codes: bundle discounts are applied by Bundlex in cart/checkout and by the COD form */
  var PCT = { 2: 15, 3: 25 };
  var WA = '971563014113';
  var TRIO = ['korean-silk-lifting-peptide-ampoule', 'dr-melaxin-tranexamic-cream-skin-freckle-cream-anti-pigmetation-for-all-skin', 'dr-melaxin-eyephalt-eye-bag-cream'];
  var TRIO_CODE = '', TRIO_PCT = 33;
  var fmt;
  try { fmt = new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: window.GBCUR || 'AED' }); }
  catch (e) { fmt = { format: function (n) { return n.toFixed(2); } }; }
  var S = window.GBS = {
    WA: WA, CODES: CODES, PCT: PCT,
    cat: function () { return window.GBC || []; },
    by: function (h) { var c = S.cat(); for (var i = 0; i < c.length; i++) if (c[i].h === h) return c[i]; return null; },
    money: function (minor) { return fmt.format(minor / 100); },
    isTrio: function (list) {
      if (list.length !== 3) return false;
      return TRIO.every(function (h) { return list.some(function (p) { return p.h === h; }); });
    },
    pct: function (n) { return n >= 3 ? PCT[3] : (n === 2 ? PCT[2] : 0); },
    code: function (n) { return ''; },
    offer: function (list) {
      if (S.isTrio(list)) return { pct: TRIO_PCT, code: TRIO_CODE };
      return { pct: S.pct(list.length), code: S.code(list.length) };
    },
    sum: function (list) {
      var sub = 0, n = list.length; list.forEach(function (p) { sub += +p.p; });
      var o = S.offer(list); return { n: n, sub: sub, pct: o.pct, total: sub * (1 - o.pct / 100), code: o.code };
    },
    cartLink: function (list) {
      var ids = list.map(function (p) { return p.id + ':1'; }).join(',');
      return '/cart/' + ids;
    },
    waLink: function (list, extra) {
      var t = S.sum(list);
      var msg = 'Hi Glambe! I would like to order:\n' + list.map(function (p) { return '- ' + p.n; }).join('\n') +
        '\nTotal: ' + S.money(t.total) + (t.pct ? ' (' + t.pct + '% bundle discount)' : '') +
        '\nPlease confirm my cash on delivery order.' + (extra ? '\n' + extra : '');
      return 'https://wa.me/' + WA + '?text=' + encodeURIComponent(msg);
    },
    esc: function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  };
})();